<template>
  <div
    class="mt-4"
    :style="`min-height:${innerHeight < 768 ? 768 : innerHeight}px`"
  >
    <div v-if="!isUpdateMode">
      <strong>
        <a class="btn btn-default btn-sm" @click="addCust()">
          <div class="d-flex align-items-center">
            <i class="icon-add_new text-orange i-18"></i>
            加入現有客戶
          </div>
        </a>
      </strong>
      <strong>
        <a class="btn btn-default btn-sm" @click="createCust()">
          <div class="d-flex align-items-center">
            <i class="icon-add_new text-orange i-18"></i>
            新增客戶
          </div>
        </a>
      </strong>
      <strong>
        <a class="btn btn-default btn-sm float-right" @click="changeUpdateMode">
          <i class="icon-edit i-18"></i>
          編輯家戶
        </a>
      </strong>
    </div>
    <div class="mt-21 d-inline-flex" v-else>
      <a class="btn btn-red btn-sm" @click="panelOpen('mvDeleteFamilyOpen')"
        >解散家戶</a
      >
      <p class="text-red mb-0 mt-2 ml-27">
        *編輯資料後，請點擊頁面右下角的「儲存」按鈕才算完成編輯。
      </p>
    </div>
    <div class="mt-21">
      <div
        class="list"
        v-if="getAllFamilyResult.length != 0"
        style="margin-bottom: 150px"
        ref="countHeight"
      >
        <div
          style="border: #bebebe solid 1px"
          class="rounded-8 col-12 pl-10 mb-2 shadow-sm"
        >
          <tr class="d-flex align-items-center">
            <th class="col-1 d-flex flex-column">
              <div v-if="!isUpdateMode" class="checkbox checkbox-inline mr-0">
                <input
                  v-model="theadAll"
                  @click="changeInput(0, 'Y')"
                  type="checkbox"
                  id="thead"
                />
                <label for="thead">
                  <span>#</span>
                </label>
              </div>
              <div
                class="d-flex align-items-center justify-content-end"
                style="height: 40px"
                v-else
              >
                <span style>#</span>
              </div>
            </th>
            <th class="col-2 d-flex justify-content-left">
              <strong
                :class="
                  !isUpdateMode
                    ? 'fw-600 ml-27 d-flex justify-content-left'
                    : ''
                "
              >
                姓名
                <span v-if="isUpdateMode" class="requireSpan">
                  <span class="star">*</span>
                  必填
                </span>
              </strong>
            </th>
            <th v-if="isUpdateMode" class="col-1 d-flex flex-column">
              <strong class="fw-600 w-left">
                性別

                <span class="requireSpan">
                  <span class="star">*</span>
                  必填
                </span>
              </strong>
            </th>
            <th
              class="d-flex justify-content-left"
              :class="isUpdateMode ? `col-2` : 'col-1'"
            >
              <strong class="fw-600">
                身份
                <span v-if="isUpdateMode" class="requireSpan">
                  <span class="star">*</span>
                  必填
                </span>
              </strong>
            </th>
            <th class="col-2 d-flex justify-content-left">
              <strong
                :class="
                  !isUpdateMode ? 'fw-600 d-flex justify-content-left' : ''
                "
                >身分證</strong
              >
            </th>
            <th
              class="d-flex flex-column"
              :class="!isUpdateMode ? 'col-2' : 'col-3'"
            >
              <strong
                :class="
                  !isUpdateMode
                    ? 'fw-600 d-flex justify-content-left'
                    : 'w-left'
                "
              >
                生日
                <span v-if="isUpdateMode" class="requireSpan">
                  <span class="star">*</span>

                  生日或年齡擇一必填
                </span>
              </strong>
            </th>
            <th class="col-1 d-flex flex-column">
              <strong class="w-left fw-600 ml-1">年齡</strong>
            </th>
            <th v-if="!isUpdateMode" class="col-2 d-flex flex-column">
              <strong
                :class="
                  !isUpdateMode ? 'fw-600 d-flex justify-content-left' : ''
                "
                >提醒</strong
              >
            </th>
            <th v-if="!isUpdateMode" class="col-1 d-flex flex-column">
              <strong
                :class="
                  !isUpdateMode ? 'fw-600 d-flex justify-content-left pl-1' : ''
                "
                style="margin-left: 10.4px !important"
                >備註</strong
              >
            </th>
          </tr>
        </div>
        <template v-for="(item, i) in getAllFamilyResult">
          <div
            v-if="!item.isDelete"
            :key="`group-item-${i}`"
            style="border: #bebebe solid 1px"
            class="rounded-8 col-12 pl-10 pt-2 pb-2 shadow-sm mb-2"
            :class="item.isDelete ? 'deleted' : ''"
          >
            <tr class="d-flex align-items-center">
              <th class="col-1 d-flex flex-column">
                <div
                  class="d-flex align-items-center justify-content-between"
                  v-if="isUpdateMode"
                >
                  <button
                    type="button"
                    class="btn btn-sm removeButton"
                    :class="item.familyrl == 0 ? 'btn-disabled' : 'btn-red'"
                    style="white-space: nowrap"
                    @click="checkSingleDelete(item)"
                  >
                    移除
                  </button>
                  <!-- <button
                  type="button"
                  class="btn btn-default btn-sm removeButton"
                  :class="item.isDelete?'deletedSapn':''"
                  @click="item.isDelete = !item.isDelete"
                  v-else
                >復原</button> -->
                  <div>{{ i + 1 }}</div>
                </div>
                <div v-else class="checkbox checkbox-inline mr-0 block-heigh">
                  <input
                    style
                    :id="`customer-${i}`"
                    :value="item.csidno"
                    type="checkbox"
                    v-model="getAllFamilyResult[i]['check']"
                    @click="changeInput(i, 'N')"
                  />
                  <label :for="`customer-${i}`">
                    <span>{{ i + 1 }}</span>
                  </label>
                </div>
              </th>
              <th class="col-2 d-flex flex-column pl-1">
                <div v-if="isUpdateMode">
                  <input
                    :name="`name-${i}`"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has(`name-${i}`) }"
                    :disabled="item.isDelete || !$checkEdit(UserInfo)"
                    class="form-control"
                    v-model="item.name"
                    v-policy.name
                    alt="ch"
                    @input="checkInputName(item)"
                    @blur="checkInputName(item)"
                  />
                </div>
                <div
                  class="d-flex align-items-center"
                  @click="toCustDetail(item.csidno || item.serNo, item.name)"
                  v-else
                >
                  <div class="mr-2" style="width: 30px">
                    <div v-if="item.vip_lvl" class="controlAvatarLevel">
                      <level :lv="Number(item.vip_lvl)" />
                    </div>
                    <div>
                      <avatar :gender="Number(item.sex)" :size="20" />
                    </div>
                  </div>
                  <Tooltip
                    :position="item.index < 4 ? 'bottom' : 'top'"
                    :id="item.csidno"
                    :birthday="formatDate(item.birthday)"
                  >
                    <div class="font-20 breakLine text-left">
                      <a :class="item.name ? 'link text-underline' : ''">{{
                        item.name ? item.name : "一 一"
                      }}</a>
                    </div>
                  </Tooltip>
                </div>
              </th>
              <th v-if="isUpdateMode" class="col-1 d-flex flex-column">
                <div>
                  <select
                    :disabled="item.isDelete || !$checkEdit(UserInfo)"
                    style="width: 100%"
                    :name="`sex-${i}`"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has(`sex-${i}`) }"
                    class="form-control form-control-inline form-wide"
                    v-model="item.sex"
                  >
                    <option
                      v-for="(type, index) in ['男', '女']"
                      v-bind:value="type == '男' ? '1' : '2'"
                      :key="index"
                    >
                      {{ type }}
                    </option>
                  </select>
                </div>
              </th>
              <th
                class="d-flex flex-column"
                :class="isUpdateMode ? `col-2` : 'col-1'"
              >
                <div v-if="isUpdateMode">
                  <select
                    :disabled="getAllFamilyResult.length < 2 || item.isDelete"
                    :name="`familyrl-${i}`"
                    v-validate="'required'"
                    :class="{ 'is-invalid': errors.has(`familyrl-${i}`) }"
                    class="form-control form-wide"
                    v-model="item.familyrl"
                  >
                    <option
                      v-for="(type, index) in familyRl"
                      v-bind:value="Number(type.role_id)"
                      :key="index"
                    >
                      {{ type.role_name }}
                    </option>
                  </select>
                </div>
                <div class="d-flex justify-content-left" v-else>
                  {{
                    familyRl.filter((el) => el.role_id == item.familyrl)[0]
                      .role_name
                  }}
                </div>
              </th>
              <th class="col-2 d-flex flex-column">
                <!-- <div v-if="isUpdateMode"> -->
                <!--取消輸入後打API檢核ID是否重複 @change="checkPid(item.csidno)"-->
                <!-- <input
                  maxlength="10"
                  v-model="item.csidno"                  
                  :class="!item.csidno.includes('~')&&item.isCsidno?'form-control hideInputBorder':'form-control'"
                  @input="selectSex(item)"
                  :style="item.csidno.includes('~')?'color: transparent;':''"
                />
              </div>
              <div
                :class="!isUpdateMode?'d-flex justify-content-left':''"
                v-else
              >{{item.csidno.includes('~')?'一 一':item.csidno}}</div> -->
                <div
                  class="d-flex align-items-center"
                  v-if="!isUpdateMode && !item.csidno"
                >
                  <strong>
                    <a
                      :class="
                        $checkEdit(UserInfo) ? 'btn-default' : 'btn-disabled'
                      "
                      class="btn btn-sm ml-2"
                      @click="panelAddIdOpen(item)"
                      >輸入身分證</a
                    >
                  </strong>
                </div>
                <div :class="'d-flex justify-content-left'" v-else>
                  {{
                    item.csidno.includes("~")
                      ? "一 一"
                      : item.csidno
                      ? item.csidno
                      : "一 一" | getMaskID
                  }}
                </div>
              </th>
              <th
                class="d-flex flex-column"
                :class="!isUpdateMode ? 'col-2' : 'col-3'"
              >
                <div v-if="isUpdateMode" class="d-flex align-items-center">
                  <!--<date-picker
                    :data-vv-name="`birthday-${i}`"
                    v-validate="{
                      required:
                        (!item.age || String(item.age).trim() === '') &&
                        item.age !== 0
                    }"
                    :input-class="{ 'is-invalid': errors.has(`birthday-${i}`) }"
                    v-model="item.birthdayROC"
                    :format="dateFormatter"
                    :language="dateLang"
                    :first-day-of-week="1"
                    :typeable="false"
                    ref="picker"
                    :disabledDates="{ from: new Date() }"
                    :disabled="item.isDelete || !$checkEdit(UserInfo)"
                    @closed="show($event,i )"
                    @input="updateDateWithFormIndex(item, i)"
                  />
                  <div v-if="$checkEdit(UserInfo)" class="d-flex justify-content-end pickerDiv">
                    <img
                      src="../../../../public/assets/common/icon-close-red.svg"
                      class="clearButton"
                      v-show="item.birthdayROC"
                      @click="$refs.picker[i].clearDate()"
                    />
                  </div>
                  <div
                    class="d-flex justify-content-end align-items-center calendarDiv"
                    tabindex="-1"
                    @click="$refs.picker[i].showCalendar()"
                    @blur="$refs.picker[i].close()"
                  >
                    <i class="icon-calendar" />
                  </div>-->

                  <BirthdayComponent
                    ref="birthday"
                    :itemData="item.birthdayROC"
                    :showErrText="false"
                    :isBirdayError="isBirdayError[i] ? isBirdayError[i] : false"
                    :validateOpen="
                      (!item.age || String(item.age).trim() === '') &&
                      item.age !== 0
                    "
                    @getTime="getTime($event, item, i, `birthday-${i}`)"
                  />
                </div>

                <!-- <div v-if="isUpdateMode">
                <select
                  style="width:90px"
                  name="birth_year"
                  d="client-birth-year"
                  class="form-control form-control-inline"
                  v-model="item['birthYear']"
                >
                  <option value="0">年份</option>
                  <option
                    v-for="(opt, y_opt_i) in birthYearOpt"
                    :key="`birth-year-${y_opt_i}`"
                    :value="opt"
                  >{{opt - 1911}}年</option>
                </select>
                <select
                  style="width:90px"
                  name="birth_year"
                  d="client-birth-year"
                  class="form-control form-control-inline"
                  v-model="item['birthMonth']"
                >
                  <option value="0">月份</option>
                  <option
                    v-for="(opt, m_opt_i) in birthMonthOpt"
                    :key="`birth-month-${m_opt_i}`"
                    :value="opt"
                  >{{opt}}月</option>
                </select>
                <select
                  style="width:90px"
                  name="birth_month"
                  d="client-birth-month"
                  class="form-control form-control-inline"
                  v-model="item['birthDate']"
                >
                  <option value="0">日期</option>
                  <option
                    v-for="(opt, d_opt_i) in birthDayOpt"
                    :key="`birth-day-${d_opt_i}`"
                    :value="opt"
                  >{{opt}}日</option>
                </select>
              </div>-->

                <div
                  :class="!isUpdateMode ? 'd-flex justify-content-left' : ''"
                  v-else
                >
                  {{
                    item.birthday
                      ? formatDate(item.birthday)
                      : "一 一" | getMaskBirthday
                  }}
                </div>
              </th>
              <th class="col-1 d-flex flex-column">
                <div v-if="isUpdateMode" class="d-flex justify-content-between">
                  <input
                    :data-vv-name="`age-${i}`"
                    v-validate="{
                      required:
                        (!item.age || String(item.age).trim() === '') &&
                        item.age !== 0,
                    }"
                    maxlength="3"
                    :class="{ 'is-invalid': errors.has(`age-${i}`) }"
                    class="form-control"
                    v-model="item.age"
                    :disabled="item.birthdayROC || !$checkEdit(UserInfo)"
                    @input="checkInputAge(item)"
                    @blur="checkInputAge(item)"
                  />
                  <span class="align-self-center"></span>
                </div>

                <div v-else class="ml-2 w-left">
                  {{ item.age || item.age === 0 ? item.age : "一 一" }}
                </div>
              </th>
              <th
                v-if="!isUpdateMode"
                class="col-2 d-flex justify-content-left"
              >
                <div class="mr-28 text-left">
                  <div>{{ item.notify }}</div>
                  <template v-if="item.memochk === 'Y'">
                    <span>本客戶尚有房貸拍賣不足餘額未清償</span>
                    (
                    <span
                      class="custGreen btn p-0 m-0"
                      @click="panelOpen('mvInfoOpen')"
                      >說明</span
                    >
                    )
                  </template>
                </div>
              </th>
              <th
                v-if="!isUpdateMode"
                class="col-1 d-flex justify-content-left"
                align="left"
              >
                <strong>
                  <a
                    v-if="
                      !item.memo || item.memo.replace(/ |\n/gm, '').length == 0
                    "
                    :class="
                      $checkEdit(UserInfo) ? 'btn-default' : 'btn-disabled'
                    "
                    class="btn btn-sm"
                    style="min-width: 52px"
                    @click="clickMemo(item, i)"
                    >備註</a
                  >
                  <a
                    v-else
                    class="link text-underline"
                    style="word-break: break-all"
                    @click="clickMemo(item, i)"
                    >{{
                      item.memo.length > 7
                        ? item.memo.substring(0, 7) + "..."
                        : item.memo
                    }}</a
                  >
                </strong>
              </th>
            </tr>
          </div>
        </template>
        <div
          class="col-md-12"
          style="height: 240px"
          ref="dateDiv"
          v-show="isOpen"
        ></div>
      </div>
      <div v-else class="text-center d-flex justify-content-center" colspan="6">
        <div
          :class="{ 'mt-4 section-loading': custsOfAgntIsLoading }"
          style="height: 20px; width: 30px"
        ></div>
        <h3 class="mb-3">{{ this.remoteDataMessage }}</h3>
      </div>
      <fixed-bottom v-show="!isScroll">
        <template slot="@function">
          <div v-if="!isUpdateMode" class="d-flex justify-content-end">
            <button
              @click="rePushMember"
              class="btn btn-default mr-3"
              type="button"
            >
              <i class="fas fa-sync mr-2"></i>
              重新歸戶
            </button>
            <button
              type="button"
              @click="pushPolicyHealthCheck"
              class="btn btn-primary mr-0"
            >
              開始保單健檢
            </button>
          </div>
          <div v-else class="d-flex justify-content-end">
            <div class="checkDeleteContent">
              {{
                checkDeleteCount
                  ? `提醒：本次儲存後，將移除${checkDeleteCount}位家戶成員`
                  : ""
              }}
            </div>
            <button
              @click="changeUpdateMode"
              class="btn btn-default btn-custStyle mr-3"
              type="button"
            >
              取消
            </button>
            <button
              type="button"
              @click="saveItems"
              class="btn btn-primary btn-custStyle mr-0"
            >
              儲存
            </button>
          </div>
        </template>
      </fixed-bottom>
    </div>
    <mv-info :open="mvInfoOpen" @close="closeModal()">
      <div v-if="isFirst" class="text font-20" slot="content">
        <div class="mt-10">為了提供壽險服務，我已確實取得客戶同意。</div>
        <div>為客戶及其家庭成員進行資料建檔！</div>
      </div>
      <div v-else class="text" slot="content">
        <div class="font-20 mt-10">
          如備註有【本客戶尚有房貸拍賣不足餘額未清償】時，請提醒客戶公司可依法抵銷其保險金債權。如有相關問題請洽
          <span class="custGreenBold">債權管理科</span>
          。(資料每月更新乙次，更新日為每月六號)
        </div>
      </div>
    </mv-info>

    <mv-delete
      :open="mvDeleteOpen"
      @close="closeMvDeleteModal()"
      @confirm="sendUpdate()"
    >
      <div class="text" slot="content">
        <div>
          本次編輯有「刪除家戶成員」，刪除後需重新歸戶，請再次確認
          <!-- <span
            v-for="(item,index) in confirmDeleteNameList"
            :key="index"
            class="text-green"
          >{{confirmDeleteNameList.length>index+1?item+'、':item}}</span>-->
        </div>
      </div>
    </mv-delete>
    <mv-delete-single
      :open="mvDeleteSingleOpen"
      @close="closeMvSingleDeleteModal()"
      @confirm="closeMvSingleDeleteModal('C')"
    >
      <div class="text font-cust" slot="content">
        <div>
          您要移除家戶成員
          <span class="text-green">{{ confirmDeleteItem.name }}</span>
          嗎？
        </div>
      </div>
    </mv-delete-single>
    <mv-delete-family
      :isFinalDelete="checkDeleteFamilyModal"
      :open="mvDeleteFamilyOpen"
      @close="closeMvFamilyDeleteModal()"
      @confirm="closeMvFamilyDeleteModal('O')"
    >
      <div class="text mb-5 font-cust" slot="content">
        <div v-if="!checkDeleteFamilyModal">
          您要解散以
          <span class="text-green">{{ familyData.name }}</span>
          為戶長的家戶嗎？若解散家戶，原家戶成員皆需重新歸戶。
        </div>
        <div v-else>
          此家戶將被解散，所有成員將需重新歸戶。確定要解散此家戶嗎？
        </div>
      </div>
    </mv-delete-family>

    <mv-add-family-modal
      :open="mvAddFamilyOpen"
      :csidno="familyData.csidno"
      @close="panelClose('mvAddFamilyOpen')"
      @confirm="panelOpen('mvAddFamilyOpen')"
    />
    <mv-Birth-Check
      :open="mvPolicyAndCustomerBirthCheckOpen"
      :diffData="diffBirthPolicies"
      @close="panelClose('mvPolicyAndCustomerBirthCheckOpen')"
      @confirm="confirmPolicyHealthCheck"
    />
    <!-- 備註 -->
    <memo-modal
      :open="memoModalOpen"
      :inputs="memoData"
      :titleName="memoName"
      :titleTipPosition="'right'"
      @submit="memoSubmit"
      @close="panelClose('memoModalOpen')"
    />

    <!-- 打開遮罩 -->
    <mv-mask :open="mvMaskOpen" :content="maskContent" />
    <add-id-modal
      :target="getAddIdItem"
      :open="addIdOpen"
      @close="panelAddIdClose()"
      @confirm="submitAddIdItem"
    >
      <div class="text mb-4 font-cust" slot="content">
        <div class="text-bold text-danger pl-1 pt-2">
          ※ 注意！【
          <span
            id="addIdNameSpan"
            class="text-black"
            style="word-break: break-all"
          ></span>
          】 輸入身分證後，不可再編輯修改，請確認後再送出！
        </div>
      </div>
    </add-id-modal>
    <check-company-colleague-prop
      :open="showCheckCompanyColleague"
      :memberName="companyColleagueList"
      @close="panelClose('showCheckCompanyColleague')"
    >
    </check-company-colleague-prop>

    <leave-page-warning-modal
      :open="leavePageWarningModalOpen"
      ref="leavePageWarningModal"
      message="編輯資料尚未儲存，請問是否繼續編輯？<br>若要儲存編輯資料請留在本頁面並點擊畫面右下角的「儲存」按鈕"
      cancelText="離開"
      submitText="是"
      @submit="panelClose('leavePageWarningModalOpen')"
      @close="panelClose('leavePageWarningModalOpen')"
    >
    </leave-page-warning-modal>
  </div>
</template>

<script>
import moment from "moment";
import Avatar from "@/desktop/views/mv/components/Avatar";
import DatePicker from "@/components/DatePicker/components/Datepicker";
import { zh } from "@/components/DatePicker/locale";
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import mvInfo from "@/desktop/views/mv/components/mvInfo";
import mvDelete from "@/desktop/views/mv/components/mvDelete";
import mvDeleteSingle from "@/desktop/views/mv/components/mvDelete";
import mvDeleteFamily from "@/desktop/views/mv/components/mvDelete";
import mvAddFamilyModal from "@/desktop/views/mv/components/mvAddFamilyModal";
import leavePageWarningModal from "@/desktop/views/mv/components/leavePageWarningModal";
import mvBirthCheck from "@/desktop/views/mv/components/policyAndCustomerBirthCheck";
import Level from "@/desktop/views/mv/components/Level";
import addIdModal from "@/desktop/views/mv/components/addIdModal";
import { idCheck } from "@/service/modules/validation";
import { getFamilyrl } from "@/service/modules/mvCommon";
import BirthdayComponent from "@/desktop/components/form/BirthdayComponent";
import MemoModal from "@/desktop/components/MemoModal";
import FixedBottom from "@/desktop/views/mv/components/modal/fixedBotton";
import RouteToCustDetailMixins from "@/mixins/RouteToCustDetail";

import {
  getFamilyMemberBycondition,
  getAllHouseholderBySales,
  getAllFamily,
  modifyFamilyMember,
  checkPolicyExist,
  isCustomerAgreeRemind,
  deleteFamily,
  getGroupInsurance,
  ckeckPropertyInsuranceCustomers,
  getOtherPropertyInsurance,
  getCustInsurance_CCIPLN4MV,
  getCustInsurance_CCIPLN2MV,
  getCustInsurance_CCIPLN1MV,
  getCustInsurance_CCIPLC1MV,
  getCustInsurance_CCIPLF1MV,
  checkBirthDayDifferent,
  differBirthDayLog,
  dotNetJavaConcat,
  getCustInfo,
  checkCompanyColleague,
} from "@/service";
import { computeAge } from "@/service/index";

import { log } from "util";
import mvMask from "@/desktop/views/mv/components/mvMask";
import HardwordMixins from "@/mixins/Hardword";
import Tooltip from "@/desktop/components/ToolTip";
import CheckCompanyColleagueProp from "@/desktop/views/mv/components/CheckCompanyColleagueProp";

export default {
  name: "Relation",
  mixins: [commonMixin, HardwordMixins, RouteToCustDetailMixins],
  data() {
    return {
      //全選
      theadAll: false,
      //業務員ID
      agidno: this.$store.state.userInfo.id,
      //前頁FAMILY DATA
      familyData: this.$store.state.userItems,
      //過濾有勾選
      familyResultFilter: [],
      //過濾未被勾選
      lastFamilyResultFilter: [],
      //MOUNTED搜尋回傳結果
      getAllFamilyResult: [],
      //是否顯示LOADING
      custsOfAgntIsLoading: false,
      remoteDataMessage: "資料讀取中，請稍候...",
      //是否要為編輯狀態
      isUpdateMode: false,
      //儲存更動前狀態
      getAllFamilyResultOriginal: [],
      //生日年
      birthYearOpt: [],
      //生日月
      birthMonthOpt: [],
      //生日日
      birthDayOpt: [],
      //生日日期錯誤檢核
      isBirdayError: [],
      //mvInfo Modal開闔
      mvInfoOpen: false,
      //mvDelete Modal開闔
      mvDeleteOpen: false,
      //mvSingleDelete Modal開闔
      mvDeleteSingleOpen: false,
      //mvDeleteFamily Modal開闔
      mvDeleteFamilyOpen: false,
      //家戶生日與保單生日不同步提醒Modal開關
      mvPolicyAndCustomerBirthCheckOpen: false,
      //即將離開本頁面提醒提醒Modal開關
      leavePageWarningModalOpen: false,
      //是否第一次進入頁面
      isFirst: true,
      //確認刪除名單
      confirmDeleteNameList: [],
      //確認單一刪除成員
      confirmDeleteItem: "",
      //判斷解散家戶Modal是否為第一次彈出
      checkDeleteFamilyModal: false,
      dateFormatter: (date) => {
        const m = date.getMonth() + 1;
        const d = date.getDate();
        const y = date.getFullYear();
        if (y < 1911) {
          return `${y}/${(m < 10 ? "0" : "") + m}/${(d < 10 ? "0" : "") + d}`;
        }
        return `${y - 1911}/${(m < 10 ? "0" : "") + m}/${
          (d < 10 ? "0" : "") + d
        }`;
      },
      dateLang: zh,
      //遮罩
      mvMaskOpen: false,
      //遮罩字樣
      maskContent: "",
      isScroll: false,
      //重新歸戶Modal
      mvAddFamilyOpen: false,
      //判斷是否已有配偶
      hasSpouse: false,
      //頁高
      innerHeight: window.innerHeight,
      //身分SELECT使用
      familyRl: [],
      //日曆下拉選單多高度顯示
      isOpen: false,
      //生日不相同的保單資料
      diffBirthPolicies: [],
      addIdOpen: false,
      addIdItem: [],
      addIdName: "",
      //.Net API回傳勾選人員
      familyMember: [],
      //編輯flag
      memoModalOpen: false,
      memoData: {
        memo: "",
        memohtml: "",
        upd_time: "",
        upd_id: "",
        upd_source: "",
        isNew: false,
        custType: "", //客戶類型 (Y:有ID / N:無ID)
      },
      memoName: "",
      memoFocus: "0",
      // 公司同事檢核 - open flag
      showCheckCompanyColleague: false,
      // 公司同事檢核 - 顯示列表
      companyColleagueList: [],
      isDeleteFamily: false,
    };
  },
  components: {
    MemoModal,
    Avatar,
    mvInfo,
    DatePicker,
    mvBirthCheck,
    mvDelete,
    mvDeleteSingle,
    mvDeleteFamily,
    mvAddFamilyModal,
    mvMask,
    FixedBottom,
    Level,
    addIdModal,
    BirthdayComponent,
    Tooltip,
    CheckCompanyColleagueProp,
    leavePageWarningModal,
  },
  computed: {
    ...mapGetters(["BaseUrl", "UserItems", "UserInfo", "AllFamilyResult"]),
    checkDeleteCount() {
      let count = 0;
      this.getAllFamilyResult.forEach((item) => {
        if (item.isDelete) {
          count++;
        }
      });
      return count;
    },
    getAddIdItem() {
      return { ...this.addIdItem[0] };
    },
    getAllFamily() { 
      return this.familyResultFilter.map((el) => el.csidno || el.serNo);
    },
    isMxf1() {
      const parentOrigin = document.referrer 
        ? new URL(document.referrer).origin  // 取得母頁面的 origin，例如 https://tagpaas.cathaylife.com.tw
        : '*';

      // 若為 tagpaas/sagpaas/agpaas 開頭，才視為mxf1 iframe 嵌入，才隱藏掉天地
      const isMxf1Host = /^https:\/\/(tagpaas|sagpaas|agpaas)\.cathaylife\.com\.tw$/.test(
        parentOrigin
      );

      return isMxf1Host;
    }

  },
  watch: {
    getAllFamilyResult: {
      handler(newValue, oldValue) {
        if (this.isUpdateMode == true) {
          let fCheck = 0;
          let fIndex;
          newValue = this.getAllFamilyResult.map((item, index) => {
            if (item.birthdayROC) {
              item.birthday = moment(item.birthdayROC).format("YYYY-MM-DD");
            }
            // item.birthday = this.formatDate(item.birthdayROC, "Y");
            // if (item.birthYear && item.birthMonth && item.birthDate) {
            //   item.birthday =
            //     item.birthYear + "-" + item.birthMonth + "-" + item.birthDate;
            //   item.age = moment().diff(
            //     moment(item.birthday).format("YYYY-MM-DD"),
            //     "years",
            //     false
            //   );
            // }

            // if (item.familyrl === 0) {
            //   fCheck++;
            //   if (fCheck > 1) {
            //     item.familyrl = 4;
            //     this.$toast.info({
            //       title: "僅能有一位「戶長」，請再次確認家戶成員的身份",
            //     });
            //   }
            // }

            return item;
          });
        } else {
          //被勾選
          this.familyResultFilter = this.getAllFamilyResult.filter(
            (item, index) => {
              return item.check == true;
            }
          );
          this.lastFamilyResultFilter = this.getAllFamilyResult.filter(
            (item, index) => {
              return item.check == false;
            }
          );
          if (
            this.familyResultFilter.length == this.getAllFamilyResult.length
          ) {
            this.theadAll = true;
          }
        }
        this.$store.commit("updateAllFamilyResult", this.getAllFamilyResult);
      },
      deep: true,
    },
  },
  methods: {
    //檢查姓名
    checkInputName(item) {
      item.name = item.name.replace(
        /[<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
      if (this.stringBytes(item.name, false, 50) > 50) {
        item.name = item.name.substring(
          0,
          this.stringBytes(item.name, true, 50)
        );
      }
    },
    //檢查年齡
    checkInputAge(item) {
      item.age = item.age.replace(
        /[a-zA-Z<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
      if (this.stringBytes(item.age, false, 3) > 3) {
        item.age = item.age.substring(0, this.stringBytes(item.age, true, 3));
      }
    },
    //判斷日曆下拉選單點選是否要增加顯示長度與滾動位移
    show(emitEvent, index) {
      let realIndex = 0;
      //過濾有顯示在頁面上的家戶資料與真實index
      let family = this.getAllFamilyResult.filter((item, i) => {
        if (i < index && !item.isDelete) {
          realIndex++;
        }
        return !item.isDelete;
      });
      let familyCount = family.length;
      if (familyCount > 3) {
        for (let i = 1; i < 6; i++) {
          if (realIndex == familyCount - i) {
            this.isOpen = !emitEvent;
            this.$refs["dateDiv"].style.height = 240 - 56 * (i - 1) + "px";
            if (this.isOpen) {
              this.$nextTick(() => {
                document.documentElement.scrollTop =
                  document.documentElement.scrollHeight;
              });
            }
          }
        }
      }
    },
    memoSubmit(memoText) {
      // 新增修改 memo
      this.getAllFamilyResult[this.memoFocus].isnew = false;
      this.getAllFamilyResult[this.memoFocus].memo = memoText;
      this.panelClose("memoModalOpen");
    },
    clickMemo(item, i) {
      if (item.csidno != "") {
        this.updateCustID(item.csidno);
        this.updateSerNo("");
        this.memoData.custType = "Y";
      } else {
        this.updateCustID("");
        this.updateSerNo(item.serNo);
        this.memoData.custType = "N";
      }
      this.memoFocus = i;

      this.memoName = item.name;
      this.registerHanlink();
      this.memoData.memo = this.getAllFamilyResult[i].memo;
      if (this.getAllFamilyResult[i].memo) {
        this.memoData.memohtml = this.getAllFamilyResult[i].memo.replace(
          /\n/gm,
          "<br/>"
        );
      } else {
        this.memoData.memohtml = "";
      }
      this.memoData.isNew = this.getAllFamilyResult[i].isnew;
      this.memoData.upd_time = this.getAllFamilyResult[i].memo_upd_time;
      this.memoData.upd_id = this.getAllFamilyResult[i].memo_upd_id;
      this.memoData.upd_source = this.getAllFamilyResult[i].memo_upd_source;

      this.panelOpen("memoModalOpen");
    },

    resizeWindow() {
      this.innerHeight = Number(this.$refs.countHeight.clientHeight + 180);
    },
    closeMvFamilyDeleteModal(type) {
      this.panelClose("mvDeleteFamilyOpen");
      if (!this.checkDeleteFamilyModal && type == "O") {
        window.setTimeout(() => {
          this.panelOpen("mvDeleteFamilyOpen");
          this.checkDeleteFamilyModal = true;
        }, 1000);
      } else if (this.checkDeleteFamilyModal && type != "O") {
        window.setTimeout(() => {
          this.checkDeleteFamilyModal = false;
        }, 1000);
      } else if (this.checkDeleteFamilyModal && type == "O") {
        this.deleteFamilyM();
        // this.checkDeleteFamilyModal = false;
      } else {
        this.checkDeleteFamilyModal = false;
      }
    },
    checkSingleDelete(item) {
      this.confirmDeleteItem = item;
      this.panelOpen("mvDeleteSingleOpen");
      // item.isDelete = !item.isDelete;
    },
    closeMvSingleDeleteModal(type) {
      if (type === "C") {
        this.confirmDeleteItem.isDelete = true;
      }
      this.panelClose("mvDeleteSingleOpen");
      window.setTimeout(() => (this.confirmDeleteItem = {}), 1000);
    },
    closeMvDeleteModal() {
      this.panelClose("mvDeleteOpen");
      this.confirmDeleteNameList = [];
    },
    closeModal() {
      this.panelClose("mvInfoOpen");
      if (this.isFirst) {
        window.setTimeout(() => (this.isFirst = false), 1000);
      }
    },
    //輸入ID Model開啟
    panelAddIdOpen(item) {
      this.addIdItem = [];
      this.addIdItem.push(item);
      this.addIdName = item.name;
      this.panelOpen("addIdOpen");

      //name有包含難字時，hanlinks套件會使name的vue物件資料綁定失效，因此改用jQuery
      $("#addIdNameSpan").text(item.name);
      this.registerHanlink();
    },
    //輸入ID Model關閉
    panelAddIdClose() {
      this.panelClose("addIdOpen");
      this.$toast.info({ title: "編輯失敗" });
    },
    //輸入ID視窗關閉後更新家戶
    submitAddIdItem(editData) {
      const senddata = { ...this.addIdItem[0], ...editData };
      this.panelClose("addIdOpen");
      this.maskContent = "資料更新中，請稍候...";
      this.panelOpen("mvMaskOpen");
      modifyFamilyMember(
        this.$store.state.userInfo.id,
        [senddata],
        this.checkDeleteCount,
        true
      )
        .then((i) => {
          this.panelClose("mvMaskOpen");
          if (i.header && i.header.status == "200") {
            this.addIdItem[0].csidno = senddata.csidno;
            this.addIdItem[0].sex = senddata.sex;
            delete this.addIdItem[0].serNo;
            if (this.addIdItem[0].familyrl == 0) {
              this.reCoverLeaderforInit(this.addIdItem[0]);
              this.init();
            }
            this.$toast.info({ title: "編輯成功" });
          } else {
            return Promise.reject(i);
          }
        })
        .catch((i) => {
          if (i.header && i.header.message) {
            let errorMessage = i.header.message;
            errorMessage = errorMessage.split("Message: ")[1].split(" ")[0];
            this.$toast.info({ title: errorMessage });
            this.panelOpen("addIdOpen");
          }
        });
    },
    stringBytes(c, isSub, size) {
      //計算字元長度 (字串, 是否檢查, 檢查的長度)
      let n = c.length;
      let s;
      let len = 0;
      for (let i = 0; i < n; i++) {
        s = c.charCodeAt(i);
        while (s > 0) {
          len++;
          s = s >> 8;
          if (isSub && len > size) {
            return i;
          }
        }
      }
      return len;
    },
    ...mapActions([
      "updateUserItems",
      "updateFamilyResultFilter",
      "updateLastFamilyResult",
      "updatePDFData",
      "updateCustID",
      "setPageLock",
      "updateSerNo",
    ]),
    moment,
    changeUpdateMode(e) {
      e.target.blur();
      if (!this.isUpdateMode) {
        this.getAllFamilyResultOriginal = JSON.parse(
          JSON.stringify(this.getAllFamilyResult)
        );
        this.getAllFamilyResultOriginal.forEach((element) => {
          if (element.birthday) {
            element["birthdayROC"] = moment(element.birthday).toDate();
          }
        });
      } else {
        this.getAllFamilyResult = JSON.parse(
          JSON.stringify(this.getAllFamilyResultOriginal)
        );
        this.getAllFamilyResult.forEach((element) => {
          if (element.birthday) {
            element["birthdayROC"] = moment(element.birthday).toDate();
          }
        });
      }
      this.isUpdateMode = !this.isUpdateMode;
    },
    chkCustExist() {
      if (this.familyResultFilter.length < 1) {
        this.$toast.info({ title: "請先勾選客戶" });
        return false;
      }
      if (this.familyResultFilter.some((x) => !x.birthday || !x.sex)) {
        this.$toast.info({
          title: "缺少「性別」或「生日」無法進行保單健檢",
        });
        return false;
      }
      return true;
    },
    async checkLifeInsuranceExist() {
      const res = await Promise.all([
        // 團險
        getGroupInsurance(this.agidno, this.getAllFamily),
        // 壽險
        checkPolicyExist(
          this.$store.state.userInfo.id,
          this.familyResultFilter.map((x) => x.csidno || x.serNo),
          this.familyData.csidno
        ),
      ]);
      if (
        !res.some(
          (x) =>
            (x.group && x.group.length) ||
            (x.body && x.body.length) ||
            (x.data && x.data.constructor === Object ) ||
            (x.data &&
              x.data.length &&
              x.data[0].constructor === Object &&
              x.data[0].policysum > 0)
        )
      ) {
        return false;
      }
      //20211210 新增保單超過數量提醒
      if (res[1].data[0] && res[1].data[0].policysum > 120) {
        localStorage.policyOverWarn = true;
      } else {
        localStorage.policyOverWarn = false;
      }
      return true;
    },
    async checkPropertyInsuranceExist() {
      const result = await ckeckPropertyInsuranceCustomers(
        this.agidno,
        this.getAllFamily
      ).catch(() => (this.isLoading = false));
      if (result.data) return true;
      return;
    },
    setSerNo() {
      this.familyResultFilter = this.familyResultFilter.map((item) => {
        if (!item.csidno || item.csidno === "") {
          item.csidno = item.serNo;
        }
        return item;
      });
      this.lastFamilyResultFilter = this.lastFamilyResultFilter.map((item) => {
        if (!item.csidno || item.csidno === "") {
          item.csidno = item.serNo;
        }
        return item;
      });
    },
    //重新歸戶
    rePushMember() {
      if (this.familyResultFilter.length < 1) {
        this.$toast.info({ title: "請先勾選客戶" });
        return false;
      }
      if (this.familyResultFilter.length > 50) {
        this.$toast.info({ title: "家戶成員不得超過50人+" });
        return false;
      }
      //選取全部成員
      if (
        this.getAllFamilyResult &&
        this.familyResultFilter &&
        this.getAllFamilyResult.length === this.familyResultFilter.length
      ) {
        //相同> 選擇現有家戶
        this.setSerNo();
        this.updateLastFamilyResult(this.lastFamilyResultFilter);
        this.updateFamilyResultFilter(this.familyResultFilter);
        this.routerToAddToFamily();
      } else {
        //Modal 請選擇歸戶方式
        this.setSerNo();
        this.updateLastFamilyResult(this.lastFamilyResultFilter);
        this.updateFamilyResultFilter(this.familyResultFilter);
        this.panelOpen("mvAddFamilyOpen");
      }
    },
    routerToAddToFamily() {
      getAllHouseholderBySales(this.$store.state.userInfo.id).then((result) => {
        //若完全沒有任何家戶，保留原頁，並顯示警示訊息「沒有可以加入的家戶」
        if (
          !result.data ||
          result.data.filter((item) => item.csidno != this.familyData.csidno)
            .length === 0
        ) {
          this.$toast.info({ title: "沒有可以加入的家戶" });
          return;
        } else {
          this.$router.push({
            name: "addToFamily",
            params: {
              isReAddFamily: true,
            },
          });
        }
      });
    },
    async pushPolicyHealthCheck() {
      if (!this.chkCustExist()) {
        return;
      }
      this.maskContent = "保單健檢計算中...";
      this.panelOpen("mvMaskOpen");
      //檢核是否為公司同事及其權限是否開啟(20250722移除)
      // checkCompanyColleague(
      //   this.agidno,
      //   this.familyResultFilter.map((x) => x.csidno)
      // ).then((result) => {
      //   if (result.body && result.body.data && result.body.data.length > 0) {
      //     this.companyColleagueList = result.body.data;
      //     this.panelClose("mvMaskOpen");
      //     this.panelOpen("showCheckCompanyColleague");
      //     return;
      //   }
      // });
        //檢核是否有生日不一致保單
        checkBirthDayDifferent(
          this.agidno,
          this.familyResultFilter.map((x) => x.csidno || x.serNo)
        ).then((result) => {
          if (result.body && result.body.data && result.body.data.length > 0) {
            this.diffBirthPolicies = result.body.data;
            this.panelClose("mvMaskOpen");
            this.panelOpen("mvPolicyAndCustomerBirthCheckOpen");
          } else {
            this.panelClose("mvMaskOpen");
            this.calculatePolicyHealth();
          }
        });
    },
    //紀錄生日不一致保單LOG
    async confirmPolicyHealthCheck() {
      differBirthDayLog(this.agidno, this.diffBirthPolicies).then((result) => {
        this.panelClose("mvPolicyAndCustomerBirthCheckOpen");
        if (result.header && result.header.status == "200") {
          this.calculatePolicyHealth();
        } else {
          this.$toast.info({ title: "系統錯誤" });
        }
      });
    },
    //開始保單健檢
    async calculatePolicyHealth() {
      let checkProperty = false;
      let hasProperty = false;
      this.maskContent = "保單健檢計算中...";
      this.panelOpen("mvMaskOpen");
      if (!(await this.checkLifeInsuranceExist())) {
        if (!(await this.checkPropertyInsuranceExist())) {
          this.panelClose("mvMaskOpen");
          this.$toast.info({
            title: "無有效保單，無法進行保單健檢",
          });
          return;
        } else {
          checkProperty = true;
          hasProperty = true;
        }
      }
      this.panelClose("mvMaskOpen");
      this.updateFamilyResultFilter(this.familyResultFilter);
      localStorage.allFamily = this.familyResultFilter
        .map((x) => x.csidno || x.serNo)
        .join(",");
      // this.$router.push({ name: "policyInfoPDF" });
      console.log("before push checkProperty", checkProperty)
      this.$router.push({ 
        name: "policyInfoPDF", 
        params: {
          checkProperty: checkProperty,
          hasProperty: hasProperty,
        }
      });
    },
    changeInput(index, chk) {
      if (chk == "Y") {
        if (this.detectIEEdge() === 11) {
          this.getAllFamilyResult.forEach(
            (element) => (element.check = this.theadAll)
          );
        } else {
          this.getAllFamilyResult.forEach(
            (element) => (element.check = !this.theadAll)
          );
        }
      } else {
        this.theadAll = false;
      }
    },
    formatDate(preDate) {
      if (preDate) {
        let dd = moment(preDate).format("YYYY-MM-DD").split("-");
        dd[0] = dd[0] - 1911;
        dd = dd.join("/");

        return dd;
      } else {
        return "";
      }
    },
    detectIEEdge() {
      var ua = window.navigator.userAgent;

      var msie = ua.indexOf("MSIE ");
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
      }

      var trident = ua.indexOf("Trident/");
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf("rv:");
        return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
      }

      var edge = ua.indexOf("Edge/");
      if (edge > 0) {
        // Edge => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
      }

      // other browser
      return false;
    },
    // +加入現有可可戶
    addCust() {
      this.$router.push({
        name: "familyAddCust",
        params: {
          isRelation: true,
          allFamilyNumber: this.getAllFamilyResult.length,
        },
      });
    },
    // +新增客戶
    createCust() {
      this.$router.push({
        name: "createCust2Family",
        params: {
          familyResult: this.getAllFamilyResult,
          hasSpouse: this.hasSpouse,
        },
      });
    },
    async updateDateWithFormIndex(data, index) {
      //判斷生日有異動才執行年齡換算
      if (
        data.birthdayROC == this.getAllFamilyResultOriginal[index].birthdayROC
      ) {
        //點擊生日欄位後若data原先沒有birthdayROC會自動生成，故要刪除
        if (!data.birthdayROC) {
          delete data.birthdayROC;
        }
        data.age = this.getAllFamilyResultOriginal[index].age;
        return;
      }

      if (data.birthdayROC) {
        await computeAge(
          this.$store.state.userInfo.id,
          window.moment(data.birthdayROC).format("YYYY-MM-DD")
        ).then((result) => {
          if (result.header && result.header.status == "200") {
            data.age = result.body.age;
          } else {
            data.age = "計算錯誤";
          }
        });
        // this.$refs.age[index].disabled = true;
      } else {
        // this.$refs.age[index].disabled = false;
        data.age = "";
      }
    },
    saveItems() {
      let fCheck = 0;
      let rCheck = 0;
      let sCheck = 0;
      let rsCheck = 0;
      let that = this;
      //重置錯誤訊息
      that.errors.items.length = 0;
      //this.getAllFamilyResult = this.getAllFamilyResult.filter(item => item.name)
      this.getAllFamilyResult.map((item, index) => {
        if (item.familyrl === 0) {
          fCheck++;
          if (fCheck > 1) {
            for (let i = 0; i < this.getAllFamilyResult.length; i++) {
              if (this.getAllFamilyResult[i].familyrl === 0) {
                that.errors.add({
                  field: `familyrl-${i}`,
                  msg: "familyrl",
                });
              }
            }
            this.$toast.info({
              title: "僅能有一位「戶長」，請再次確認家戶成員的身份",
            });
            rCheck++;
          }
        }
        if (item.familyrl === 1) {
          sCheck++;
          if (sCheck > 1) {
            for (let i = 0; i < this.getAllFamilyResult.length; i++) {
              if (this.getAllFamilyResult[i].familyrl === 1) {
                that.errors.add({
                  field: `familyrl-${i}`,
                  msg: "familyrl",
                });
              }
            }
            if (rsCheck === 0) {
              this.$toast.info({
                title: "僅能有一位「配偶」，請再次確認家戶成員的身份",
              });
            }
            rsCheck++;
          }
        }
        if (item.isDelete) {
          this.confirmDeleteNameList.push(item.name);
        }
        return item;
      });
      if (fCheck < 1) {
        for (let i = 0; i < this.getAllFamilyResult.length; i++) {
          that.errors.add({
            field: `familyrl-${i}`,
            msg: "familyrl",
          });
        }
        this.$toast.info({
          title: "家中需有一位「戶長」，請再次確認",
        });
        return false;
      }
      if (rCheck > 0 || rsCheck > 0) return false;

      let _this = this;
      async function asyncStart() {
        let check = true;
        await Promise.all(
          _this.$refs.birthday.map(async (e) =>
            (await e.validateAll()) === false ? (check = false) : ""
          )
        );

        //檢核生日
        let birthdayErrorCount = 0;
        _this.isBirdayError = [];
        _this.getAllFamilyResult.map((item, index) => {
          if (
            item.birthdayROC &&
            !moment(item.birthdayROC).isSameOrBefore(moment(), "day")
          ) {
            _this.isBirdayError.push(true);
            birthdayErrorCount++;
          } else {
            _this.isBirdayError.push(false);
          }
        });
        if (birthdayErrorCount > 0) {
          _this.$toast.info({ title: "出生日期不得超過今日" });
          return false;
        }

        _this.$validator.validateAll().then((el) => {
          if (el) {
            if (_this.confirmDeleteNameList.length > 0) {
              // this.panelOpen("mvDeleteOpen");
              _this.sendUpdate();
            } else {
              _this.sendUpdate();
            }
          } else {
            for (let i = 0; i < _this.errors.items.length; i++) {
              let el = _this.errors.items[i];
              if (el.field.includes("age") || !check) {
                _this.$toast.info({ title: "「生日」、「年齡」須擇一填寫" });
                break;
              } else {
                _this.$toast.info({ title: "尚有必填欄位待確認" });
                break;
              }
            }
            console.log("儲存失敗");
          }
        });
      }
      asyncStart();
    },
    async sendUpdate() {
      new Promise((resolve) => {
        this.maskContent = "資料更新中，請稍候...";
        this.panelOpen("mvMaskOpen");
        resolve();
      }).then(() => {
        let familyLeader = this.getAllFamilyResult.filter((item) => {
          if (item.familyrl == 0) {
            return true;
          } else {
            return false;
          }
        });
        //提升效能僅傳送有修改的資料
        let originalFamilyrl = this.getAllFamilyResultOriginal.filter(
          (item) => item.familyrl === 0
        );
        let newFamilyrl = this.getAllFamilyResult.filter(
          (item) => item.familyrl === 0
        );
        //判斷戶長是否有修改，若有則同步更新所有家戶資料
        let isChangeFamilyrl =
          JSON.stringify(originalFamilyrl) !== JSON.stringify(newFamilyrl);
        let changedData = this.getAllFamilyResult.filter((item, index) => {
          if (isChangeFamilyrl) {
            return true;
          }
          return (
            JSON.stringify(item) !==
            JSON.stringify(this.getAllFamilyResultOriginal[index])
          );
        });

        if (changedData.length == 0) {
          this.isUpdateMode = false;
          this.panelClose("mvMaskOpen");
          this.$validator.reset();
          return;
        }
        //為避免畫面切換前顯示修改過後Map的id故先複製作為參數傳遞
        let modifyData = JSON.parse(JSON.stringify(changedData));
        modifyFamilyMember(
          this.$store.state.userInfo.id,
          modifyData,
          this.checkDeleteCount,
          false
        ).then((result) => {
          console.log("jjijijiji");
          if (result.header && result.header.status == "200") {
            //為防止變更戶長為無ID成員時導致重查查無資料
            familyLeader[0].csidno = familyLeader[0].csidno
              ? familyLeader[0].csidno
              : familyLeader[0].serNo;
            this.isUpdateMode = false;
            this.reCoverLeaderforInit(familyLeader[0]);
            this.init();
            this.$toast.info({ title: "編輯成功" });
            this.panelClose("mvMaskOpen");
          } else {
            if (result.header && result.header.message) {
              let errorMessage = result.header.message;
              if (
                errorMessage.split("Message: ").length > 1 &&
                errorMessage.split(" ").length > 1
              ) {
                errorMessage = errorMessage.split("Message: ")[1].split(" ")[0];
              }
              this.$toast.info({ title: errorMessage });
            }
            this.panelClose("mvMaskOpen");
          }
        });
        this.$validator.reset();
      });
    },
    reCoverLeaderforInit(familyLeader) {
      //更新戶長資料
      this.updateUserItems(familyLeader);
      localStorage.userItems = JSON.stringify(familyLeader);
      this.familyData = familyLeader;
    },
    selectSex(item) {
      if (item.csidno.length > 1) {
        var sexOfId = item.csidno.substr(1, 1);
        if (sexOfId.toUpperCase().match("1|8|A|C")) {
          item.sex = 1;
        } else if (sexOfId.toUpperCase().match("2|9|B|D")) {
          item.sex = 2;
        }
        item.csidno = item.csidno.toUpperCase();
      }
    },

    //取消輸入後打API確認ID是否重複，故先註解
    // checkPid(str) {
    //   if (str.substring(0, 1) == "~" || str.substring(0, 1) == "*") {
    //     return true;
    //   } else {
    //     if (str.length == 10) {
    //       getFamilyMemberBycondition(this.$store.state.userInfo.id, str).then(
    //         (result) => {
    //           if (result.header && result.header.status == "200") {
    //             if (result.data.length > 0) {
    //               this.$toast.info({ title: "此ID已重複，請確認資料是否正確" });
    //             }
    //           }
    //         }
    //       );
    //     }
    //     if (str == null || str == "") {
    //       this.$toast.info({ title: "此ID格式有誤" });
    //     }
    //     /* 檢查身分證字號 */
    //     if (!idCheck(str)) {
    //       this.$toast.info({ title: "此ID格式有誤" });
    //     }
    //   }
    // },
    binarySearch(ar, el) {
      var m = 0;
      var n = ar.length - 1;
      while (m <= n) {
        var k = (n + m) >> 1;
        var cmp = this.compare_number(el, ar[k]);
        if (cmp > 0) {
          m = k + 1;
        } else if (cmp < 0) {
          n = k - 1;
        } else {
          return k;
        }
      }
      return -m - 1;
    },
    compare_number(a, b) {
      return a - b;
    },
    init() {
      console.log("init (userItems)", this.familyData)
      //回壓
      // if (!this.familyData.csidno.includes("~")) {
      //   this.updateCustID(this.familyData.csidno);
      //   this.updateSerNo("");
      //   localStorage.CustID = this.familyData.csidno;
      //   localStorage.SerNo = "";
      //   localStorage.checkMvBack = true
      // } else {
      //   this.updateCustID("");
      //   this.updateSerNo(this.familyData.csidno);
      //   localStorage.CustID = "";
      //   localStorage.SerNo = this.familyData.csidno;
      //   localStorage.checkMvBack = true
      // }
      //刪除保單資訊勾選人員
      localStorage.allFamily = "";
      //如為舊保健回來
      if (this.$route.query.concatCode) {
        dotNetJavaConcat(
          this.$store.state.userInfo.id,
          this.$route.query.concatCode
        ).then((result) => {
          this.familyData = result.data.familydata;
          //無戶長資料回首頁
          if (!this.familyData || this.familyData.length < 1) {
            this.$router.push({ name: "allHolder" });
          }
          //更新戶長資料
          this.updateUserItems(this.familyData);
          this.familyMember = result.data.familymember;
          this.initFamily();
        });
      } else {
        if (!this.familyData || this.familyData.length < 1) {
          this.familyData = JSON.parse(localStorage.userItems);
        }
        isCustomerAgreeRemind(
          this.$store.state.userInfo.id,
          this.familyData.csidno
        ).then((result) => {
          this.mvInfoOpen = !result.data;
        });
        this.initFamily();
      }

      // this.initGroupVue();

      // F5 重新整理方案

      // if(this.$store.state.userInfo.id === ''){
      //   setTimeout(() => {
      //     this.initGroupVue()
      //   }, this.$store.state.timeoutVal);
      // }else{
      //   this.initGroupVue()
      // }
    },
    initFamily() {
      let start = moment().year();
      this.birthYearOpt = Array.apply(null, { length: 101 }).map(function (
        value,
        index
      ) {
        return start - index;
      });
      this.birthMonthOpt = Array.apply(null, Array(12)).map(function (x, i) {
        return (i + 1).toString().padStart(2, "0");
      });
      this.birthDayOpt = Array.apply(null, Array(31)).map(function (x, i) {
        return (i + 1).toString().padStart(2, "0");
      });
      this.remoteDataMessage = "資料讀取中，請稍候...";
      this.custsOfAgntIsLoading = true;
      getAllFamily(this.familyData.agidno, this.familyData.csidno).then(
        (result) => {
          // if (result.header && result.header.status == "200") {
          //   console.log(result.data);
          // }
          result.data.forEach((element) => {
            element.check = this.theadAll;
            element["isDelete"] = false;
            if (element.birthday) {
              element["birthdayROC"] = moment(element.birthday).toDate();
            }
            if (!element.csidno.includes("~")) {
              element["isCsidno"] = true;
            } else {
              element["serNo"] = element.csidno;
              element.csidno = "";
            }
            if (element.familyrl === 1) {
              this.hasSpouse = true;
            }
            // if (element.birthday) {
            //   element["birthYear"] = element.birthday.split("-")[0];
            //   element["birthMonth"] = element.birthday.split("-")[1];
            //   element["birthDate"] = element.birthday.split("-")[2];
            // } else {
            //   element["birthYear"] = "0";
            //   element["birthMonth"] = "0";
            //   element["birthDate"] = "0";
            // }
          });
          this.getAllFamilyResult = result.data;
          this.remoteDataMessage =
            "無任何家戶(請先將客戶完成歸戶，才能開始使用保單健檢)";
          this.$nextTick(() => {
            console.log(
              "this.$refs.countHeight.clientHeight+100",
              this.$refs.countHeight.clientHeight + 180
            );
            this.innerHeight = Number(
              this.$refs.countHeight.clientHeight + 180
            );
          });
          //如為.Net回來 勾選成員並執行保單健檢
          if (
            this.$route.query.concatCode &&
            !this.$store.state.userInfo.userType === "box"
          ) {
            this.getAllFamilyResult = this.getAllFamilyResult.map((el) => {
              if (this.familyMember.includes(el.csidno || el.serNo)) {
                el.check = true;
                this.familyResultFilter.push(el);
              }
              return el;
            });
            this.pushPolicyHealthCheck();
          }
        }
      );
    },
    toCustDetail(csid, name) {
      if (this.isMxf1) {
        const parentOrigin = document.referrer 
        ? new URL(document.referrer).origin 
        : '*';
        window.parent.postMessage(
          {
            type: "SET_CSID",
            // 沿用新版 MXF1 既有的 Base64 客戶識別協議，無 ID 的「~serNo」也保留原值。
            csid: btoa(csid),
          },
        parentOrigin
        );
        return true;
      }
      if (name) {
        this.routeToCustDetail(csid, name);
      }
    },
    deleteFamilyM() {
      this.getAllFamilyResult = this.getAllFamilyResult.map((item) => {
        if (!item.csidno || item.csidno === "") {
          item.csidno = item.serNo;
        }
        return item;
      });
      deleteFamily(this.$store.state.userInfo.id, this.getAllFamilyResult).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.isDeleteFamily = true;
            this.$router.push({ name: "allHolder" });
            this.$toast.info({ title: "家戶已解散" });
          } else {
            this.$toast.info({ title: "家戶解散失敗" });
          }
        }
      );
    },
    getTime(event, item, index, ageField) {
      item.birthdayROC = event.date;
      if (!item.age) {
        this.$set(item, "age", "");
      }
      item.age = event.age;
    },
    handlePostMessage(event) {
      // 限制來源網域為 *.cathaylife.com.tw
      const allowedOriginRegex = /^https?:\/\/([a-zA-Z0-9-]+\.)*cathaylife\.com\.tw$/;
      if (!allowedOriginRegex.test(event.origin)) return;

      const { type, csid } = event.data || {};
      if (type === 'SET_CSID' && csid) {
        // Todo：做被通知有CSID時要做的事情
       console.log('postMessage received csid:', csid);
      }
    }

  },
  beforeRouteLeave(to, from, next) {
    if (from.name == "relation" && this.isUpdateMode && !this.isDeleteFamily) {
      this.panelOpen("leavePageWarningModalOpen");
      this.$nextTick(() => {
        this.$refs.leavePageWarningModal.$once("submit", () => {
          if (from.name == "relation" && to.name == "policyInfo") {
            $("#familyRelationNavLink").addClass("active");
            $("#policyInfoNavLink").removeClass("active");
          }
          next(false);
        });
        this.$refs.leavePageWarningModal.$once("close", () => {
          next();
        });
      });
    } else {
      next();
    }
  },
  mounted() {
    this.familyRl = getFamilyrl();
    this.init();
    if (this.isMxf1) {
      window.addEventListener('message', this.handlePostMessage);

      // 通知母畫面 iframe 已載入完成
      const parentOrigin = document.referrer 
        ? new URL(document.referrer).origin 
        : '*';
      window.parent.postMessage(
        { type: 'IFRAME_READY' },
        parentOrigin,
      );
    }

  },
  beforeDestroy() {
    // 移除監聽，避免 memory leak
    if (this.isMxf1) {
      console.log('removeEventListener for postMessage');
      window.removeEventListener('message', this.handlePostMessage);
    }
  },
  created() {
    window.addEventListener("resize", this.resizeWindow);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeWindow);
  },
};
</script>
scss
<style lang="scss" scoped>
.ccc {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  text-align: center;
}
.deleted {
  opacity: 0.5;
  background: rgb(241, 241, 205);
}
.deletedSapn {
  color: red;
  background: rgb(241, 241, 205);
}
.breakLine {
  word-break: break-all;
  min-width: 50px;
  max-width: 115px;
}
.font-24 {
  font-size: 24px;
}
.requireSpan {
  width: 47px;
  height: 20px;
  font-size: 13px;
  border-radius: 4px;
  background-color: #feeedd;
}
.font-20 {
  font-size: 20px;
}
.mr-13 {
  margin-right: 13px;
}
.mr-28 {
  margin-right: 28px;
}
.ml-10 {
  margin-left: 10px;
}
.ml-27 {
  margin-left: 27px;
}
.mt-10 {
  margin-top: 10px;
}
.mt-21 {
  margin-top: 21px;
}
.removeButton {
  font-size: 14px;
  margin-left: -9px !important;
}
.custGreen {
  color: #048f3a;
}
.w-left {
  width: 100%;
  text-align: left;
}
.hideInputBorder {
  pointer-events: none;
  border: 0px solid white;
}
.hideInputValue {
  color: transparent;
}
.fw-600 {
  font-weight: 600;
}
.custGreenBold {
  font-weight: 600;
  color: #027a39;
}
.textLeft {
  text-align: left;
}
.rounded-8 {
  border-radius: 8px;
}
.star {
  width: 13px;
  height: 18px;
  font-family: PingFangTC;
  font-size: 13px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #de4054;
}

.btn-disabled {
  color: #c2c4c7;
  border-radius: 4px;
  border: solid 1px #989ca2;
  background: #ffffff !important;
  pointer-events: none;
}
.btn-custStyle {
  padding-top: 9px !important;
  width: 120px;
  height: 40px;
}
.levelPosition {
  position: absolute;
  top: -15px;
  left: -100%;
  right: -17%;
  margin: auto;
}

.font-cust {
  font-family: PingFangTC;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.65;
  letter-spacing: normal;
  color: #323a45;
}

.checkDeleteContent {
  font-family: PingFangTC;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: right;
  color: #323a45;
  line-height: 50px;
  margin-right: 20px;
}

.controlAvatarLevel {
  height: 17px;
}

.clearButton {
  position: relative;
  width: 18px;
  pointer-events: auto;
}

.pickerDiv {
  position: absolute;
  padding-right: 10px;
  width: 130px;
  height: 40px;
  font-size: 22px;
  color: #f58818;
  pointer-events: none;
}

.calendarDiv {
  margin: 0 10px 0 5px;
  height: 40px;
  font-size: 24px;
  color: #f58818;
  outline: none;
}

.icon-calendar:before {
  position: relative;
  margin: 0;
  pointer-events: none;
}

div /deep/ .vdp-datepicker input {
  width: 130px;
}
</style> 